export default __webpack_public_path__ + "static/media/cake-demo.d73d3327.gif";